import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { OptionType } from 'src/app/core/enums/enums';
import { Country, SearchForm } from 'src/app/core/models/itinerary.model';
import { ContractError } from 'src/app/core/models/models';
import { BookingSearchActions } from '../actions';
import { GenericError } from 'src/app/layout/actions/layout.actions';
import { ChangeToPnrSplitted, SplitPnrSuccess } from 'src/app/search-result/actions/pnr.actions';

export interface DashboardState {
  searchForm: SearchForm;
  countries: Country[];
  error: ContractError;
  loading: boolean;
  country: string;
}

export interface State {
  dashboard: DashboardState;
}

export const initialState: DashboardState = {
  searchForm: null,
  countries: [],
  error: null,
  loading: false,
  country: ''
};

const dashboardReducer = createReducer(
  initialState,
  on(GenericError, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(BookingSearchActions.SubmitSearchForm, (state, { searchForm }) => ({
    ...state,
    searchForm,
    loading: false
  })),
  on(BookingSearchActions.LoadItinerary, (state) => ({
    ...state,
    loading: false
  })),
  on(ChangeToPnrSplitted, (state, { cancellationQuote }) => ({
    ...state,
    searchForm: {
      ...state.searchForm,
      pnr: cancellationQuote.pnr,
      searchType: 'pnr'
    }
  })),
  on(SplitPnrSuccess, (state, { pnr }) => ({
    ...state,
    searchForm: {
      ...state.searchForm,
      pnr: pnr.code,
      searchType: 'pnr'
    }
  }))
);

export function reducer(state: DashboardState | undefined, action: Action): DashboardState {
  return dashboardReducer(state, action);
}

export const selectDashboard = createFeatureSelector<DashboardState>(OptionType.Dashboard);

export const selectLoading = createSelector(
  selectDashboard,
  (state: DashboardState) => state.loading
);

export const selectSearchForm = createSelector(
  selectDashboard,
  (state: DashboardState) => state.searchForm
);
